type SvgProps = React.SVGProps<SVGSVGElement>;

export const RocketIconWithBorder = (props: SvgProps) => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5625"
      y="0.5625"
      width="43.875"
      height="43.875"
      rx="21.9375"
      fill="#EEE9FF"
    />
    <rect
      x="0.5625"
      y="0.5625"
      width="43.875"
      height="43.875"
      rx="21.9375"
      stroke="url(#paint0_linear_3425_15338)"
      stroke-width="1.125"
    />
    <g clip-path="url(#clip0_3425_15338)">
      <path
        d="M14.0655 27.3983C13.3414 28.398 12.8218 29.5308 12.5363 30.7317C12.4818 30.9707 12.4888 31.2197 12.5567 31.4554C12.6246 31.691 12.7513 31.9055 12.9247 32.0789C13.0981 32.2522 13.3127 32.3788 13.5484 32.4466C13.7841 32.5144 14.0331 32.5213 14.2721 32.4667C15.4712 32.1807 16.6021 31.6614 17.6005 30.9383C18.0699 30.4695 18.3339 29.8335 18.3343 29.1701C18.3348 28.5067 18.0717 27.8703 17.603 27.4008C17.1342 26.9314 16.4981 26.6674 15.8347 26.6669C15.1713 26.6665 14.5349 26.9295 14.0655 27.3983ZM16.4221 29.7558C15.7505 30.186 15.0209 30.5182 14.2555 30.7425C14.48 29.9772 14.8122 29.2476 15.2421 28.5758C15.3993 28.424 15.6098 28.34 15.8283 28.3419C16.0468 28.3438 16.2558 28.4315 16.4103 28.586C16.5648 28.7405 16.6525 28.9495 16.6544 29.168C16.6563 29.3865 16.5723 29.597 16.4205 29.7542L16.4221 29.7558ZM27.4996 19.5833C27.4996 20.1359 27.2801 20.6658 26.8894 21.0565C26.4987 21.4472 25.9688 21.6667 25.4163 21.6667C24.8638 21.6667 24.3339 21.4472 23.9432 21.0565C23.5525 20.6658 23.333 20.1359 23.333 19.5833C23.333 19.0308 23.5525 18.5009 23.9432 18.1102C24.3339 17.7195 24.8638 17.5 25.4163 17.5C25.9688 17.5 26.4987 17.7195 26.8894 18.1102C27.2801 18.5009 27.4996 19.0308 27.4996 19.5833ZM29.9763 12.5C27.9932 12.4882 26.034 12.9336 24.2509 13.8016C22.4678 14.6696 20.9087 15.9369 19.6946 17.505C18.3706 17.5508 17.0719 17.8813 15.8871 18.4742C14.5131 19.1068 13.3915 20.1827 12.7021 21.5292C12.5403 21.9048 12.4747 22.3148 12.5111 22.7222C12.5474 23.1295 12.6847 23.5214 12.9105 23.8625C13.1384 24.2119 13.4499 24.4989 13.8167 24.6975C14.1835 24.8961 14.5941 25.0001 15.0113 25H17.083C17.8554 25.0037 18.5951 25.3122 19.1412 25.8584C19.6874 26.4045 19.9959 27.1442 19.9996 27.9167V29.9883C19.9993 30.4053 20.103 30.8158 20.3014 31.1826C20.4997 31.5495 20.7864 31.861 21.1355 32.0892C21.4765 32.3149 21.8684 32.4522 22.2758 32.4886C22.6831 32.5249 23.0932 32.4593 23.4688 32.2975C24.8152 31.6081 25.8911 30.4865 26.5238 29.1125C27.1166 27.9277 27.4472 26.629 27.493 25.305C29.0636 24.0879 30.3324 22.5249 31.2007 20.7377C32.0691 18.9504 32.5135 16.987 32.4996 15C32.4986 14.67 32.4325 14.3434 32.3051 14.039C32.1776 13.7346 31.9914 13.4584 31.757 13.2261C31.5225 12.9939 31.2446 12.8102 30.939 12.6856C30.6334 12.561 30.3063 12.4979 29.9763 12.5ZM16.1213 23.3333H15.0113C14.8704 23.3344 14.7315 23.2997 14.6076 23.2325C14.4837 23.1654 14.3789 23.0679 14.303 22.9492C14.2283 22.8389 14.1827 22.7116 14.1704 22.5791C14.158 22.4465 14.1792 22.313 14.2321 22.1908C14.7691 21.2068 15.6127 20.4249 16.6346 19.9642C17.1627 19.6994 17.7201 19.498 18.2955 19.3642C17.4672 20.6278 16.7402 21.955 16.1213 23.3333ZM25.038 28.365C24.5772 29.3867 23.7957 30.2302 22.8121 30.7675C22.6898 30.8205 22.5562 30.8417 22.4235 30.8294C22.2908 30.817 22.1633 30.7713 22.053 30.6967C21.9343 30.6207 21.8368 30.5159 21.7696 30.392C21.7024 30.2681 21.6677 30.1292 21.6688 29.9883V28.8783C23.0471 28.2594 24.3743 27.5325 25.638 26.7042C25.5033 27.2796 25.3011 27.8371 25.0355 28.365H25.038ZM25.1505 25.015C24.0228 25.7982 22.8324 26.4869 21.5913 27.0742C21.4218 26.1642 20.9808 25.3269 20.3263 24.6724C19.6719 24.0179 18.8346 23.577 17.9246 23.4075C18.5123 22.1675 19.2013 20.9782 19.9846 19.8517C22.7913 15.9367 25.6996 14.2892 29.9996 14.1667C30.2167 14.1666 30.4252 14.2512 30.5808 14.4024C30.7364 14.5537 30.8269 14.7597 30.833 14.9767C30.7105 19.3 29.063 22.2083 25.148 25.015H25.1505Z"
        fill="#784EFF"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3425_15338"
        x1="22.5"
        y1="0"
        x2="22.5"
        y2="45"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BBA7FF" />
        <stop offset="1" stop-color="#BBA7FF" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_3425_15338">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(12.5 12.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
